import { FunctionalComponent } from 'preact'
import { connectHits } from 'react-instantsearch-dom'
import { Hit } from '../algolia/components'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  hits?: Hit[]
  topicId: string
  totalItemCount: number
}

export const RelatedIdeasList: FunctionalComponent<Props> = (props: Props) => {
  const { hits = [], topicId, totalItemCount } = props
  const hitsWithoutCurrent = hits
    .filter((hit) => hit.id !== parseInt(topicId))
    .slice(0, totalItemCount)

  if (!hitsWithoutCurrent.length) {
    return null
  }

  return (
    <div className='box__content widget box__pad widget--related-ideas'>
      <h3 className='widget-title related-ideas__widget-title'>
        <Phrase p='related.ideas.title' />
      </h3>
      <ul class='simple-topic-list'>
        {hitsWithoutCurrent.map((hit, index) => (
          <li key={index} className='related-ideas__topic simple-topic-list--item'>
            <h6 className='related-ideas__topic-title simple-topic-list--title'>
              <a className='link link--topic' href={hit.topic_url}>
                {hit.title}
              </a>
            </h6>
          </li>
        ))}
      </ul>
    </div>
  )
}

const RelatedTopicsListContainer = connectHits(RelatedIdeasList)

export default RelatedTopicsListContainer
